import React, { Fragment, useEffect, useState } from "react";
import { Formik } from "formik";
import PageTitle from "../../layouts/PageTitle";
import { userValidationSchema } from "../../../utils/validationSchemas/userValidationSchema.js";
import CustomMobileWithCountryCode from "../../components/Forms/CustomInputs/CustomMobileWithCountryCode.jsx";
import { ReactComponent as DeleteIconSvg } from "../../../images/iconly/Delete.svg";
import { ReactComponent as SendIconSvg } from "../../../images/iconly/Send.svg";
import { useSelector } from "react-redux";

function getLocalDateInputMaxYmd() {
  const t = new Date();
  const y = t.getFullYear();
  const m = String(t.getMonth() + 1).padStart(2, "0");
  const d = String(t.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

const DOB_PICKER_EMPTY_ANCHOR_YMD = "2000-01-01";

function setNativeDateInputValue(input, ymd) {
  const desc = Object.getOwnPropertyDescriptor(
    window.HTMLInputElement.prototype,
    "value"
  );
  if (desc?.set) desc.set.call(input, ymd);
  else input.value = ymd;
}

const UsersFormUI = ({
  initialValues,
  handleFormSubmit,
  usersData,
  setSelectedCountry,
  handleDeleteUser,
  handleUpdatePasswordAndSend,
  handleSendPassword,
  passwordActionLoading,
}) => {
  const roles = useSelector((state) => state.rbac.data);
  // const roles = ["Core Team", "Mentors", "Executive Team", "Volunteers"];
  const [isPasswordDirty, setIsPasswordDirty] = useState(false);
  const [showMaskedPassword, setShowMaskedPassword] = useState(true);

  useEffect(() => {
    setIsPasswordDirty(false);
  }, [usersData]);

  return (
    <Fragment>
      <style>
        {`
          .dob-placeholder {
            color: transparent !important;
          }
          .dob-placeholder::placeholder {
            color: #6c757d !important;
            opacity: 1 !important;
          }
        `}
      </style>
      <PageTitle
        activeMenu="Users"
        motherMenu="Form"
        pageContent="Add / Edit UNM Team Member"
      />
      <Formik
        initialValues={initialValues}
        validationSchema={userValidationSchema}
        onSubmit={handleFormSubmit}
        enableReinitialize
      >
        {({
          values,
          errors,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
          setFieldValue,
          touched,
          setFieldTouched,
          submitCount,
        }) => (
          <div className="row">
            <div className="col-lg-10">
              <form onSubmit={handleSubmit} className="users-form-wrapper">
                <div className="card p-4">
                  <div className="row m-0">
                    <div className="card-header p-0 border-0 pb-3 d-flex justify-content-between align-items-center">
                      <h4 className="card-title">
                        {usersData?._id ? "Edit" : "Add"} UNM Team Member
                      </h4>

                      {/* {usersData?._id && (
                        <div className="form-check form-switch col-auto">
                          <label
                            className="form-check-label text-capitalize"
                            htmlFor="status"
                          >
                            {values.status == "active" ? "Active" : "Inactive"}
                          </label>
                          <input
                            type="checkbox"
                            className="form-check-input custom-switch"
                            id="status"
                            checked={values.status}
                            onChange={(e) =>
                              setFieldValue("status", e.target.checked)
                            }
                          />
                        </div>
                      )} */}

                      {usersData?._id && (
                        <div className="form-check form-switch col-auto d-flex align-items-center">
                          <label
                            className="form-check-label mr-10"
                            htmlFor="status"
                            style={{ marginRight: "50px", marginBottom: "0px" }}
                          >
                            {values.status === "active" ? "Active" : "Inactive"}
                          </label>

                          <input
                            type="checkbox"
                            className="form-check-input custom-switch"
                            id="status"
                            checked={values.status === "active"}
                            onChange={
                              (e) =>
                                setFieldValue(
                                  "status",
                                  e.target.checked ? "active" : "inactive"
                                )
                            }
                          />
                        </div>
                      )}
                    </div>

                    <div className="row align-items-stretch g-0">
                      <div className="col-lg-7 pe-4">
                        <div className="row">
                          <div className="form-group col-md-6 mb-3">
                            <label className="text-label">First Name *</label>
                            <input
                              name="firstname"
                              type="text"
                              placeholder="First name"
                              value={values.firstname ?? ""}
                              onChange={(e) => {
                                if (
                                  /^[a-zA-Z\s]*$/.test(e.target.value) ||
                                  e.target.value === ""
                                )
                                  handleChange(e);
                              }}
                              onBlur={handleBlur}
                              className={`form-control input`}
                            />
                            {errors.firstname && touched.firstname && (
                              <div className="invalid-feedback d-block">
                                {errors.firstname}
                              </div>
                            )}
                          </div>

                          <div className="form-group col-md-6 mb-3">
                            <label className="text-label">Last Name *</label>
                            <input
                              name="lastname"
                              type="text"
                              placeholder="Last name"
                              value={values.lastname ?? ""}
                              onChange={(e) => {
                                if (
                                  /^[a-zA-Z\s]*$/.test(e.target.value) ||
                                  e.target.value === ""
                                )
                                  handleChange(e);
                              }}
                              onBlur={handleBlur}
                              className={`form-control input`}
                            />
                            {errors.lastname && touched.lastname && (
                              <div className="invalid-feedback d-block">
                                {errors.lastname}
                              </div>
                            )}
                          </div>

                          <div className="form-group col-12 mb-3">
                            <label className="text-label">
                              Email Address *
                            </label>
                            <input
                              name="email"
                              type="email"
                              placeholder="you@example.com"
                              value={values.email ?? ""}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              className={`form-control input`}
                            />
                            {errors.email && touched.email && (
                              <div className="invalid-feedback d-block">
                                {errors.email}
                              </div>
                            )}
                          </div>

                          <div className="form-group col-12 mb-3">
                            <CustomMobileWithCountryCode
                              fieldName="mobile"
                              countryCodeField="country_code"
                              value={values.mobile}
                              error={
                                (touched.mobile || submitCount > 0) &&
                                errors.mobile
                                  ? errors.mobile
                                  : ""
                              }
                              label={"Mobile Number *"}
                              classes={"w-100"}
                              // handleBlur={handleBlur}
                              handleBlur={() => {
                                setFieldTouched("mobile", true, true);
                              }}
                              setSelectedCountry={setSelectedCountry}
                              inputType={"text"}
                              setFieldValue={setFieldValue}
                              country_code={values?.country_code}
                              handleChange={(e) => {
                                if (e.target.value === "") {
                                  setFieldValue("mobile", "");
                                } else if (/^[0-9]*$/.test(e.target.value)) {
                                  setFieldValue("mobile", e.target.value);
                                }
                              }}
                            // maxLength={15}
                            // minLength={10}
                            />
                          </div>

                          <div className="form-group col-12 mb-3">
                            <label className="text-label">
                              Date of Birth *
                            </label>
                            <div style={{ position: 'relative' }}>
                              <input
                                name="dob"
                                type="date"
                                max={getLocalDateInputMaxYmd()}
                                value={values.dob ?? ""}
                                onChange={handleChange}
                                onFocus={(e) => {
                                  if (values.dob) return;
                                  const el = e.currentTarget;
                                  setNativeDateInputValue(
                                    el,
                                    DOB_PICKER_EMPTY_ANCHOR_YMD
                                  );
                                  try {
                                    el.showPicker?.();
                                  } catch (_) {}
                                }}
                                onBlur={(e) => {
                                  if (!values.dob) {
                                    setNativeDateInputValue(e.currentTarget, "");
                                  }
                                  handleBlur(e);
                                }}
                                className={`form-control input ${!values.dob ? "dob-placeholder" : ""}`}
                              />
                              {!values.dob && (
                                <div
                                  style={{
                                    position: 'absolute',
                                    top: '50%',
                                    left: '12px',
                                    transform: 'translateY(-50%)',
                                    color: '#6c757d',
                                    pointerEvents: 'none',
                                    fontSize: '14px',
                                    zIndex: 1
                                  }}
                                >
                                  dd/mm/yyyy
                                </div>
                              )}
                            </div>
                            {(touched.dob || submitCount > 0) && errors.dob && (
                              <div className="invalid-feedback d-block">
                                {errors.dob}
                              </div>
                            )}
                          </div>

                          <div className="form-group col-12 mb-3">
                            <label className="text-label">Organisation</label>
                            <input
                              name="organisation"
                              type="text"
                              placeholder="Organisation"
                              value={values.organisation ?? ""}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              className="form-control"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-5 ps-4 d-flex flex-column">
                        <div className="role-box mb-3">
                          <label className="text-label">Role *</label>
                          {errors.role && touched.role && (
                            <div className="invalid-feedback d-block">
                              {errors.role}
                            </div>
                          )}
                          <div className="role-options">
                            {roles.map((r) => (
                              <div className="form-check role-row" key={r}>
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="role"
                                  value={r._id}
                                  id={`role-${r._id}`}
                                  checked={values.role == r._id}
                                  onChange={handleChange}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor={`role-${r._id}`}
                                >
                                  {r.title.toUpperCase().replace(/_/g, " ")}
                                </label>
                              </div>
                            ))}
                          </div>
                        </div>

                        <div className="password-note">
                          <label className="text-label">Password *</label>
                          <div className="text-label" style={{ fontWeight: 'normal', marginTop: '5px' }}>
                            User's password will be sent to his/her email
                          </div>
                          {/* <div className="row">
                            <div className="d-flex align-items-start gap-2">
                              <input
                                type="text"
                                name="password"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.password ?? ""}
                                placeholder="Send the user's password to their registered email."
                                className="form-control input"
                              />
                              {errors.password && touched.password && (
                                <div className="invalid-feedback d-block">
                                  {errors.password}
                                </div>
                              )}

                              {usersData?._id && (
                                <button
                                  type="button"
                                  className="btn btn-outline-primary btn-sm"
                                  disabled={isPasswordDirty}
                                  // onClick={() => handleSendPassword(usersData._id)}
                                >
                                  Send Password
                                </button>
                              )}
                            </div>
                           </div> */}
                          <div className="row">
                            <div
                              className={`${usersData?._id ? "col-6" : "col-12"
                                }`}
                            >
                              <input
                                type="text"
                                name="password"
                                onChange={(e) => {
                                  handleChange(e);
                                  setShowMaskedPassword(false);
                                  if (usersData?._id) {
                                    setIsPasswordDirty(true);
                                  }
                                }}
                                onFocus={() => {
                                  if (usersData?._id && showMaskedPassword) {
                                    setShowMaskedPassword(false);
                                  }
                                }}
                                onBlur={handleBlur}
                                // value={values.password ?? ""}
                                value={
                                  usersData?._id && showMaskedPassword
                                    ? "******"
                                    : values.password ?? ""
                                }
                                placeholder="Create Strong Password"
                                className="form-control input"
                              />
                              {errors.password && touched.password && (
                                <div className="invalid-feedback d-block">
                                  {errors.password}
                                </div>
                              )}
                            </div>
                            {/* {usersData?._id && !isPasswordDirty && (
                              <div className="col-6 d-flex align-items-center">
                                <button
                                  type="button"
                                  className="btn btn-outline-primary w-100"
                                  // disabled={isPasswordDirty}
                                  // onClick={() => handleSendPassword(usersData._id)}
                                >
                                  <span style={{ marginRight: "10px" }}>
                                    Send Password
                                  </span>
                                  <SendIconSvg />
                                </button>
                              </div>
                            )} */}
                            {usersData?._id && (
                              <div className="col-6 d-flex align-items-center">
                                <button
                                  type="button"
                                  className="btn btn-outline-primary w-100"
                                  disabled={passwordActionLoading}
                                  onClick={() => {
                                    if (isPasswordDirty) {
                                      handleUpdatePasswordAndSend(
                                        usersData._id,
                                        values.password
                                      );
                                    } else {
                                      handleSendPassword(usersData._id);
                                    }
                                  }}
                                  style={{ padding: "8px" }}
                                >
                                  {/* <span style={{ marginRight: "10px" }}>
                                    {isPasswordDirty
                                      ? "Update Password"
                                      : "Send Password"}
                                  </span>
                                  {isPasswordDirty ? "" : <SendIconSvg />} */}

                                  {passwordActionLoading ? (
                                    <>
                                      <span
                                        // className="spinner-border spinner-border-sm me-2"
                                        // role="status"
                                        // aria-hidden="true"
                                        style={{ color: "black" }}
                                      >
                                        Processing...
                                      </span>
                                    </>
                                  ) : (
                                    <>
                                      <span style={{ marginRight: "10px" }}>
                                        {isPasswordDirty
                                          ? "Update Password"
                                          : "Send Password"}
                                      </span>
                                      {isPasswordDirty ? "" : <SendIconSvg />}
                                    </>
                                  )}
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="d-flex justify-content-between mt-4 p-1">
                      {usersData?._id && (
                        <button
                          type="button"
                          className="btn btn-outline-primary"
                          style={{
                            marginLeft: "0 !important",
                            marginTop: "1.7rem",
                          }}
                          onClick={() => handleDeleteUser(usersData._id)}
                        >
                          <DeleteIconSvg />
                          <span style={{ marginLeft: "10px" }}>
                            Delete User
                          </span>
                        </button>
                      )}
                      <div className="ms-auto">
                        <button
                          type="submit"
                          className="btn btn-primary float-end d-inline-flex align-items-center gap-2"
                          style={{
                            marginRight: "0 !important",
                            marginTop: "1.7rem",
                          }}
                          disabled={isSubmitting}
                        >
                          {isSubmitting && (
                            <span
                              className="spinner-border spinner-border-sm"
                              role="status"
                              aria-hidden="true"
                            />
                          )}
                          {isSubmitting
                            ? "Saving..."
                            : usersData?._id
                              ? "Update User"
                              : "Save"}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        )}
      </Formik>
    </Fragment>
  );
};

export default UsersFormUI;
